export default "__VITE_ASSET__CKkhv6dL__"